import { c as classnames } from './index-2586sEvh.js';
import React, { useContext } from 'react';
import Link from './components/Link/index.js';
import { CoreContext } from './context/index.js';

const MenuItem = ({ item, setShowMobileMenu }) => {
    var _a;
    const { data: { locale }, } = useContext(CoreContext);
    const title = item.localized_menu_item_title || item.original_title;
    return (React.createElement("li", null,
        React.createElement(Link, { href: `/${locale}${item.url}`, onClick: () => {
                setShowMobileMenu(false);
            }, className: "sub-link" },
            title,
            React.createElement("i", { className: "icon-right-arrow" })),
        React.createElement("div", { className: "third-block" }, (_a = item.children) === null || _a === void 0 ? void 0 : _a.map((childItem, index) => {
            const childTitle = childItem.localized_menu_item_title || childItem.original_title;
            return (React.createElement(Link
            // eslint-disable-next-line react/no-array-index-key
            , { 
                // eslint-disable-next-line react/no-array-index-key
                key: `/${locale}${childItem.url}_${index}`, href: childItem.url, className: classnames('third-link', childItem.item_class), onClick: () => setShowMobileMenu(false) },
                React.createElement("span", null, childTitle)));
        }))));
};

export { MenuItem as M };
//# sourceMappingURL=MenuItem-ap5gxdWe.js.map
